import React, { useState } from 'react';
import { Box, Typography, Paper, Switch, FormControlLabel, Button, Grid, Divider, TextField, FormControl, InputLabel, Select, MenuItem } from '@mui/material';
import { Settings, Notifications, Language, Palette, Save } from '@mui/icons-material';

const SettingsPage: React.FC = () => {
  const [settings, setSettings] = useState({
    emailNotifications: true,
    smsNotifications: false,
    pushNotifications: true,
    transactionAlerts: true,
    marketingEmails: false,
    language: 'pt-BR',
    timezone: 'America/Sao_Paulo',
    dateFormat: 'DD/MM/YYYY',
    theme: 'light',
  });

  const handleSwitchChange = (field: string) => (e: React.ChangeEvent<HTMLInputElement>) => {
    setSettings({ ...settings, [field]: e.target.checked });
  };

  const handleSelectChange = (field: string) => (e: any) => {
    setSettings({ ...settings, [field]: e.target.value });
  };

  return (
    <Box>
      <Typography variant="h5" fontWeight="bold" sx={{ mb: 3 }}>
        <Settings sx={{ mr: 1, verticalAlign: 'middle' }} />
        Configurações
      </Typography>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              <Notifications sx={{ mr: 1, verticalAlign: 'middle', fontSize: 20 }} />
              Notificações
            </Typography>

            <FormControlLabel
              control={<Switch checked={settings.emailNotifications} onChange={handleSwitchChange('emailNotifications')} />}
              label="Notificações por e-mail"
            />
            <br />
            <FormControlLabel
              control={<Switch checked={settings.smsNotifications} onChange={handleSwitchChange('smsNotifications')} />}
              label="Notificações por SMS"
            />
            <br />
            <FormControlLabel
              control={<Switch checked={settings.pushNotifications} onChange={handleSwitchChange('pushNotifications')} />}
              label="Notificações push"
            />

            <Divider sx={{ my: 2 }} />

            <FormControlLabel
              control={<Switch checked={settings.transactionAlerts} onChange={handleSwitchChange('transactionAlerts')} />}
              label="Alertas de transações"
            />
            <br />
            <FormControlLabel
              control={<Switch checked={settings.marketingEmails} onChange={handleSwitchChange('marketingEmails')} />}
              label="E-mails promocionais"
            />
          </Paper>
        </Grid>

        <Grid item xs={12} md={6}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              <Language sx={{ mr: 1, verticalAlign: 'middle', fontSize: 20 }} />
              Regional
            </Typography>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Idioma</InputLabel>
              <Select value={settings.language} label="Idioma" onChange={handleSelectChange('language')}>
                <MenuItem value="pt-BR">Português (Brasil)</MenuItem>
                <MenuItem value="en-US">English (US)</MenuItem>
                <MenuItem value="es">Español</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth sx={{ mb: 2 }}>
              <InputLabel>Fuso Horário</InputLabel>
              <Select value={settings.timezone} label="Fuso Horário" onChange={handleSelectChange('timezone')}>
                <MenuItem value="America/Sao_Paulo">Brasília (GMT-3)</MenuItem>
                <MenuItem value="America/Manaus">Manaus (GMT-4)</MenuItem>
                <MenuItem value="America/Cuiaba">Cuiabá (GMT-4)</MenuItem>
              </Select>
            </FormControl>

            <FormControl fullWidth>
              <InputLabel>Formato de Data</InputLabel>
              <Select value={settings.dateFormat} label="Formato de Data" onChange={handleSelectChange('dateFormat')}>
                <MenuItem value="DD/MM/YYYY">DD/MM/YYYY</MenuItem>
                <MenuItem value="MM/DD/YYYY">MM/DD/YYYY</MenuItem>
                <MenuItem value="YYYY-MM-DD">YYYY-MM-DD</MenuItem>
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Paper sx={{ p: 3 }}>
            <Typography variant="subtitle1" fontWeight="bold" sx={{ mb: 2 }}>
              <Palette sx={{ mr: 1, verticalAlign: 'middle', fontSize: 20 }} />
              Aparência
            </Typography>

            <FormControl sx={{ minWidth: 200 }}>
              <InputLabel>Tema</InputLabel>
              <Select value={settings.theme} label="Tema" onChange={handleSelectChange('theme')}>
                <MenuItem value="light">Claro</MenuItem>
                <MenuItem value="dark">Escuro</MenuItem>
                <MenuItem value="system">Sistema</MenuItem>
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12}>
          <Button variant="contained" startIcon={<Save />}>
            Salvar Configurações
          </Button>
        </Grid>
      </Grid>
    </Box>
  );
};

export default SettingsPage;
